import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

/**
 * ReuseSignalBanner
 *
 * Surfaces the "blast radius" of editing a reusable LMS asset (quiz, swipe
 * deck, or form) ONLY when it's actually shared, i.e. embedded by reference
 * across 2+ sections. For a brand-new or single-use asset the reminder was
 * just noise, so nothing renders.
 *
 * Driven by `section_usage_count` from the asset detail endpoints (opt-in via
 * the `include_section_usage` query param). Renders as a compact inline pill
 * (not a full-width bar) so it reads as a contextual chip rather than a band
 * stretching across the modal's panels.
 */
function ReuseSignalBanner({ count }) {
  // Only show when the asset is shared across multiple sections. Unknown
  // usage (create flow / not requested) or a single-use asset → nothing.
  if (count == null || count < 2) {
    return null;
  }

  return (
    <div className="inline-flex items-center gap-1.5 rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-xs font-medium text-amber-800">
      <InfoOutlinedIcon style={{ fontSize: 14 }} className="shrink-0" />
      <span>Shared asset: edits apply to {count} sections.</span>
    </div>
  );
}

export default ReuseSignalBanner;
